import type { ReactElement } from 'react';
import type { Csrf } from 'common/types';

export type Props = Csrf;

export function CSRFInputField({ token, param }: Props): ReactElement {
  return <input type="hidden" name={param} value={token} />;
}
